import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/leads_/details/$leadId/bank-request/new-request')({});
